export default "__VITE_ASSET__BwGsaGLc__"